module.exports = __webpack_public_path__ + "assets/img/111.12a9e5cc.png";